import { ExtensionDefinition } from "@backstage/frontend-plugin-api";
import {
    EntityCardBlueprint,
    EntityContentBlueprint,
} from "@backstage/plugin-catalog-react/alpha";

/**
 * Entity content extension that renders the Security Insights tab on catalog
 * entity pages for Component entities.
 */
export const securityInsightsContent: ExtensionDefinition =
    EntityContentBlueprint.make({
        name: "entity-dashboard",
        params: {
            path: "/security",
            title: "Security",
            filter: "kind:component",
            group: "security",
            loader: () =>
                import("../views/SecurityInsightsTab").then(m => (
                    <m.SecurityInsightsTab />
                )),
        },
    });

/**
 * Entity content extension that renders the Security Insights card on catalog
 * entity pages for Component entities.
 */
export const securityInsightsEntityCard: ExtensionDefinition =
    EntityCardBlueprint.make({
        name: "security-insights-entity-card",
        params: {
            filter: "kind:component",
            loader: () =>
                import(
                    "@internal/backstage-plugin-security-insights-react"
                ).then(m => <m.EntityCard />),
        },
    });

/**
 * Entity content extension that renders the group-scoped Security dashboard on
 * catalog entity pages for Group entities.
 */
export const groupSecurityContent: ExtensionDefinition =
    EntityContentBlueprint.make({
        name: "group-dashboard",
        params: {
            path: "/security",
            title: "Security",
            filter: "kind:group",
            group: "security",
            loader: () =>
                import("../views/GroupSecurityTab").then(m => (
                    <m.GroupSecurityTab />
                )),
        },
    });
